var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:['report-grid', { dark: _vm.dark, pointer: _vm.toWeb }],on:{"click":_vm.handleClick}},[_c('div',{class:['grid-title', { dark: _vm.dark }],style:({ color: _vm.titleColor })},[_vm._v(" "+_vm._s(_vm.title)+" ")]),_c('div',{staticClass:"grid-number",style:({ color: _vm.color })},[_vm._v(_vm._s(_vm.number))])])
}
var staticRenderFns = []

export { render, staticRenderFns }